<template>
    <Dialog :header="$t('AppAlertsDictionaryModal.Alerta')" :visible.sync="showDialog" :contentStyle="{'overflow': 'visible'}"
            @hide="handleClose" :style="{width: width_dialog}" :modal="true">
        <form class="kt-form" @submit.prevent>
            <div class="kt-portlet__body">
                <div class="form-group">
                    <label>{{ $t('AppAlertsDictionaryModal.Código') }}</label>
                    <app-input class="form-control" type="number" placeholder=""
                               v-model="form.code"
                               :class="{'is-invalid' : $v.form.code.$invalid && $v.form.code.$dirty}">
                    </app-input>
                    <span class="form-text error"
                          v-if="$v.form.code.$invalid && $v.form.code.$dirty">
                            {{ $t('AppAlertsDictionaryModal.Obrigatório informar o código') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>{{ $t('AppAlertsDictionaryModal.Descrição') }}</label>
                    <app-input class="form-control" type="text" placeholder=""
                               v-model="form.description"
                               :class="{'is-invalid' : $v.form.description.$invalid && $v.form.description.$dirty}">
                    </app-input>
                    <span class="form-text error"
                          v-if="$v.form.description.$invalid && $v.form.description.$dirty">
                            {{ $t('AppAlertsDictionaryModal.Obrigatório informar a descrição') }}

                    </span>
                </div>
                <div class="form-group">
                    <label>{{ $t('AppAlertsDictionaryModal.Fabricante') }}</label>
                    <br>
                    <Dropdown v-model="form.manufacturer_id" :options="manufacturers"
                              :placeholder="$t('AppAlertsDictionaryModal.Selecione')" style="width: 100%"
                              @change="changeManufacturer"
                              class="p-column-filter" :showClear="true" optionLabel="name" optionValue="id">
                        <template #option="slotProps">
                            {{ slotProps.option.name }}
                        </template>
                    </Dropdown>
                </div>
                <div class="form-group">
                    <label>{{ $t('AppAlertsDictionaryModal.Modelo') }}</label>
                    <br>
                    <Dropdown v-model="form.model_id" :options="models"
                              :placeholder="$t('AppAlertsDictionaryModal.Selecione')" style="width: 100%"
                              class="p-column-filter" :showClear="true" optionLabel="name" optionValue="id"
                              :class="{'p-invalid-custom': $v.form.model_id.$invalid && $v.form.model_id.$dirty}">
                        <template #option="slotProps">
                            {{ slotProps.option.name }}
                        </template>
                    </Dropdown>
                </div>
            </div>
        </form>

        <template #footer>
            <app-button @handleClick="handleClose" type="secondary">
                <span class="pi pi-times"></span>
                {{ $t('AppAlertsDictionaryModal.Fechar') }}
            </app-button>
            <app-button @handleClick="handleSalve" type="primary">
                <span class="pi pi-check"></span>
                {{ $t('AppAlertsDictionaryModal.Salvar') }}
            </app-button>

        </template>
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import ProgressSpinner from 'primevue/progressspinner';
import Button from 'primevue/button';
import AppButton from "../../../../common/AppButton";
import AppInput from "../../../../common/AppInput";
import Dropdown from 'primevue/dropdown';
import {STATUSES} from '../AppOptions';
import {required, maxValue} from "vuelidate/lib/validators";
import TextArea from 'primevue/textarea';
import AlertsDictionaryService from "../../../../../services/AlertsDictionaryService";
import axios from "@/axios/axios-auth";


export default {
    beforeMount() {
        this.alertsDictionaryService = new AlertsDictionaryService();
        this.getManufacturers();
    },
    mounted() {
        this.width_dialog = this.isScreenMobile ? '90vw' : '40vw';
    },
    data() {
        return {
            width_dialog: null,
            showDialog: false,
            statuses: STATUSES,
            form: {
                id: null,
                code: null,
                description: null,
                manufacturer_id: null,
                model_id: null
            },
            alertsDictionaryService: null,
            manufacturers: [],
            models: []
        }
    },
    methods: {
        sortArrayByName(values) {
            try {
                return values.sort((a, b) => a.name.localeCompare(b.name));
            } catch (e) {
                console.log(e);
                return values;
            }
        },
        getManufacturers() {
            let vm = this;
            axios.get('/api/v3/machine/manufacturers')
                .then(function (response) {
                    if (response.status === 200 && response.data.length > 0) {
                        vm.manufacturers = vm.sortArrayByName(response.data);
                    }
                }).catch(function (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppVehiclesForm.Não foi possivel recuperar a lista de fabricante'),
                    life: 5000
                });
            })
        },
        async changeManufacturer() {
            try {
                let response = await axios.get(`/api/v1/manufacturers/vehicles/${this.form.manufacturer_id}`);
                if (response.status === 200 && response.data.models.length > 0) {
                    this.models = this.sortArrayByName(response.data.models);
                }
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppVehiclesForm.Não foi possível recuperar a lista de modelos'),
                    life: 5000
                });
            }
        },
        handleClose() {
            this.$emit('handleClose');
            this.$v.$reset();
        },
        handleSalve() {

            this.$v.form.$touch();

            if (!this.$v.form.$invalid) {
                this.$emit('handleSalve', {
                    model_id: this.form.model_id,
                    code: parseInt(this.form.code),
                    description: this.form.description
                });
            }
        }
    },
    props: {
        displayDialogEditAlert: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    watch: {
        displayDialogEditAlert: function (val) {
            this.showDialog = val;
        }
    },
    components: {
        Dialog, ProgressSpinner, Button, AppButton, AppInput, Dropdown, TextArea
    },
    validations: {
        form: {
            code: {required, maxValue: maxValue(2147483647)},
            description: {required},
            model_id: {required},
        }
    },
    computed: {
        isScreenMobile: function () {
            return window.screen.width <= 1024;
        }
    }
}
</script>

<style scoped lang="scss">
@import "src/components/views/alerts/style";
</style>
